import { Injectable } from '@angular/core';
import { StudySearchStrategy } from '@models/searchStrategy.model';
import { StudyDetailService } from './study-detail.service';
import { StudyService } from './study.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StudyAnalysisService {
  public totalCount?: number;
  // keywordScreeningResultAcceptedCount: accepted results when keyword screening completed
  public keywordScreeningResultAcceptedCount?: number;
  public keywordScreeningResultCount?: number;
  public bdMatrixCount?: number;
  public internetReviewCount?: number;
  public financialReviewCount?: number;
  public masterMatrixCount?: number;

  constructor(private studyService: StudyService, private studyDetailService: StudyDetailService) {}

  public initStudyAnalysisCount() {
    const study = this.studyDetailService.study;
    if (study) {
      const searchStrategy = study.searchStrategies.find((s) => s.isActive);
      this.updateStudyAnalysisCount(searchStrategy);
    }
  }

  public updateStudyAnalysisCount(studyAnalysis: StudySearchStrategy): void {
    if (studyAnalysis) {
      this.totalCount = studyAnalysis.totalCount;
      this.keywordScreeningResultAcceptedCount = studyAnalysis.keywordScreeningResultAcceptedCount;
      this.keywordScreeningResultCount = studyAnalysis.keywordScreeningResultCount;
      this.bdMatrixCount = studyAnalysis.bdMatrixCount;
      this.internetReviewCount = studyAnalysis.internetReviewCount;
      this.financialReviewCount = studyAnalysis.financialReviewCount;
      this.masterMatrixCount = studyAnalysis.masterMatrixCount;
    }
  }

  public clearStudyAnalysisCount(): void {
    this.totalCount = null;
    this.keywordScreeningResultAcceptedCount = null;
    this.bdMatrixCount = null;
    this.internetReviewCount = null;
    this.financialReviewCount = null;
    this.masterMatrixCount = null;
  }

  public async updateStudyAnalysisHeaderCount(searchStrategyId: number): Promise<void> {
    const searchStrategy = await this.studyService.GetSearchStrategyHeaderCount(searchStrategyId);

    this.updateStudyAnalysisCount(searchStrategy);
    this.updateStudySearchStrategyCountsInStudyDetailService(searchStrategy);
  }

  public getSearchStrategyHeaderCount$(studySearchStrategyId): Observable<StudySearchStrategy> {
    return this.studyService.GetSearchStrategyHeaderCount$(studySearchStrategyId);
  }

  public updateStudySearchStrategyCountsInStudyDetailService(searchStrategy: StudySearchStrategy) {
    this.studyDetailService.study.searchStrategies[0].totalCount = searchStrategy.totalCount;
    this.studyDetailService.study.searchStrategies[0].keywordScreeningResultAcceptedCount = searchStrategy.keywordScreeningResultAcceptedCount;
    this.studyDetailService.study.searchStrategies[0].keywordScreeningResultCount = searchStrategy.keywordScreeningResultCount;
    this.studyDetailService.study.searchStrategies[0].bdMatrixCount = searchStrategy.bdMatrixCount;
    this.studyDetailService.study.searchStrategies[0].internetReviewCount = searchStrategy.internetReviewCount;
    this.studyDetailService.study.searchStrategies[0].financialReviewCount = searchStrategy.financialReviewCount;
    this.studyDetailService.study.searchStrategies[0].masterMatrixCount = searchStrategy.masterMatrixCount;
  }

  public clearStudySearchStrategyCountsInStudyDetailService() {
    this.studyDetailService.study.searchStrategies[0].totalCount = null;
    this.studyDetailService.study.searchStrategies[0].keywordScreeningResultAcceptedCount = null;
    this.studyDetailService.study.searchStrategies[0].bdMatrixCount = null;
    this.studyDetailService.study.searchStrategies[0].internetReviewCount = null;
    this.studyDetailService.study.searchStrategies[0].financialReviewCount = null;
    this.studyDetailService.study.searchStrategies[0].masterMatrixCount = null;
  }
}
